<template>
    <div class="ticket-field">
        {{ label }}
        <span v-if="value">
            {{ value || '-' }}
        </span>
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    export default defineComponent({
        name: 'TicketField',
        props: {
            label: {
                type: String as PropType<string | null>,
            },
            value: {
                type: String as PropType<string | null>,
            },
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Field';
</style>
